import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import isMobilePhone from "validator/lib/isMobilePhone";
import { Device } from "../../store/apis/devicesApi";

export const AddDeviceForm = ({
  open,
  handleAddClose,
  handleAddDevice,
  handleRemoveDevice,
  device,
  id,
}: {
  open: boolean;
  handleAddClose: () => void;
  handleAddDevice: (newDevice: Device) => void;
  handleRemoveDevice?: (id: number) => void;
  device?: Device;
  id?: string;
}) => {
  const initErrors: Device = {
    deviceId: "",
    location: "",
    phoneNumber: "",
    smsTemplate: "",
    alarmPhoneNumber: "",
  };

  const [deviceId, setDeviceId] = useState("");
  const [location, setLocation] = useState("");
  const [alarmPhoneNumber, setAlarmPhoneNumber] = useState("+358");
  const [errors, setErrors] = useState<Device>(initErrors);

  const [confirmDeleteOpen, setConfimDeleteOpen] = useState(false);

  useEffect(() => {
    if (id) {
      setDeviceId(id);
    }
  }, [id]);

  const validatePhoneNumbers = (numbers: string): boolean => {
    const numberList = numbers.split(",").map((num) => num.trim());
    console.log("Validoidaan numerot:", numberList);
    return numberList.every((num) => {
      // Poistetaan mahdolliset välilyönnit numerosta
      const cleanNumber = num.replace(/\s+/g, "");
      console.log("Puhdas numero:", cleanNumber);
      return isMobilePhone(cleanNumber, "any", { strictMode: false });
    });
  };

  const close = () => {
    setErrors(initErrors);
    handleAddClose();
  };

  const addDevice = () => {
    const err: Device = {
      deviceId: "",
      location: "",
      phoneNumber: "",
      smsTemplate: "",
      alarmPhoneNumber: "",
    };
    let errors = false;
    if (location.length < 1) {
      errors = true;
      err.location = "Anna laitteen sijanti tai muu tunniste";
    }
    if (deviceId.length < 1) {
      errors = true;
      err.deviceId = "Anna laitteen ID";
    }
    if (!validatePhoneNumbers(alarmPhoneNumber)) {
      errors = true;
      err.alarmPhoneNumber =
        "Anna puhelinnumerot kansainvälisessä muodossa pilkulla eroteltuina, esim. +358 40 123 1234, +358 40 123 1235";
    }
    if (!errors) {
      handleAddDevice({
        id: device ? device.id : undefined,
        location,
        deviceId: deviceId,
        alarmPhoneNumber,
      });
      close();
    } else {
      setErrors(err);
    }
  };

  useEffect(() => {
    if (!open) {
      setDeviceId("");
      setLocation("");
      setAlarmPhoneNumber("");
    }
    if (open && device) {
      setDeviceId(device.deviceId);
      setLocation(device.location);
      setAlarmPhoneNumber(device.alarmPhoneNumber);
    }
  }, [open, device]);

  const renderRemove = () => {
    if (device) {
      return (
        <div style={{ flex: "1 0 0 ", marginLeft: "15px" }}>
          <Button color={"warning"} onClick={() => setConfimDeleteOpen(true)}>
            Poista
          </Button>
        </div>
      );
    }
    return <div />;
  };

  const handleClose = () => {
    setConfimDeleteOpen(false);
  };

  const handleDelete = () => {
    if (handleRemoveDevice && device) {
      handleRemoveDevice(device.id!);
    }
    handleClose();
    close();
  };

  return (
    <Dialog open={open} onClose={close}>
      <Dialog open={confirmDeleteOpen} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">{"Haluatko varmasti poistaa laitteen?"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>Peru</Button>
          <Button onClick={handleDelete} autoFocus>
            Poista
          </Button>
        </DialogActions>
      </Dialog>
      <DialogTitle>Lisää laite</DialogTitle>
      <DialogContent>
        <TextField
          error={Boolean(errors.deviceId)}
          helperText={errors.deviceId}
          autoFocus
          margin="dense"
          id="deviceId"
          label="Laitteen ID"
          type="text"
          fullWidth
          variant="standard"
          onChange={(event) => setDeviceId(event.target.value)}
          value={deviceId}
        />
        <TextField
          error={Boolean(errors.location)}
          helperText={errors.location}
          autoFocus
          margin="dense"
          id="location"
          label="Laitteen sijainti"
          type="text"
          fullWidth
          variant="standard"
          onChange={(event) => setLocation(event.target.value)}
          value={location}
        />
        <TextField
          error={Boolean(errors.alarmPhoneNumber)}
          helperText={errors.alarmPhoneNumber}
          autoFocus
          margin="dense"
          id="alarmPhoneNumber"
          label="Hälytyksen puhelinnumerot (pilkulla eroteltuina)"
          type="text"
          fullWidth
          variant="standard"
          onChange={(event) => setAlarmPhoneNumber(event.target.value)}
          value={alarmPhoneNumber}
        />
      </DialogContent>
      <DialogActions>
        {renderRemove()}
        <Button onClick={close}>Peru</Button>
        <Button onClick={addDevice}>{device ? "Muokkaa" : "Lisää"}</Button>
      </DialogActions>
    </Dialog>
  );
};
